'use client'

import httpClient from '@apiClient'
import CloseButton from '@component/closeButton'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import MaskLoading from '@component/loading/mask'
import useTrackSuburb from '@hooks/useTrackSuburb'
import { trackDataLayer } from '@plugin/google/gtm/modules/suburb'
import getEstimateRoute from '@plugin/searchRoute/modules/estimate'
import getHouseRoute from '@plugin/searchRoute/modules/house'
import { estimateMap, houseList } from '@router'
import { houseSearchType } from '@routerConfig'
import { get, pick } from 'lodash-es'
import { useCallback, useMemo } from 'react'
import { useMount } from 'react-use'

export default function TrackSuburbContent() {


  const { suburb, tracking, hideTrackSuburb, changeSuburb, toggleTracking } = useTrackSuburb()

  const trackSuburb = useCallback(async () => {
    const tracked = get(suburb, 'basic.tracked', false)
    const suburbId = get(suburb, 'basic.id')
    toggleTracking(true)
    await httpClient.put('location-track', { suburbId }).finally(() => {
      toggleTracking(false)
    })
    changeSuburb({ ...suburb, basic: { ...suburb.basic, tracked: !tracked } })
    trackDataLayer.success()
  }, [suburb, changeSuburb, toggleTracking])

  useMount(() => {
    trackSuburb()
  })

  const estimateMapRoute = useMemo(() => {
    const estimateRoute = getEstimateRoute()
    estimateRoute.setSuburbs(pick(suburb.basic, ['id', 'level', 'slug', 'label']))
    return estimateMap(estimateRoute.toSlug())
  }, [suburb])

  const houseMapRoute = useMemo(() => {
    const houseRoute = getHouseRoute()
    houseRoute.setSuburbs(pick(suburb.basic, ['id', 'level', 'slug', 'label']))
    houseRoute.changeMapVisible(true)
    return houseList(houseSearchType.residential, houseRoute.toSlug())
  }, [suburb])

  return (
    <div className='relative p-10 sm:px-26 sm:py-30 md:w-[670px]'>
      <CloseButton className='absolute z-10 right-0 top-0 sm:translate-x-1/3 sm:-translate-y-1/3' circle onClick={hideTrackSuburb}></CloseButton>
      <div className='w-470 max-w-full mx-auto space-y-20'>
        <div className='text-font text-lg'>You’re now tracking {get(suburb, 'basic.suburbName')}</div>
        <div className='text-neutral-5 text-sm'>This suburb has now been saved. You can keep track of recent listings, sales, analysis and more.</div>
        <div className='text-font text-base'>Discover more about {get(suburb, 'basic.suburbName')}</div>
        <div className='grid grid-cols-1 gap-10 sm:grid-cols-2'>
          <DisablePrefetchLink href={estimateMapRoute} className='button-primary-out flex-1 h-46'>View property estimates</DisablePrefetchLink>
          <DisablePrefetchLink href={houseMapRoute} className='button-orange flex-1 h-46'>View houses for sale</DisablePrefetchLink>
        </div>
      </div>
      <MaskLoading loading={tracking}></MaskLoading>
    </div>
  )
}